/* Version: 3.5.155 */
'use client';
var common = {
  branding: {
    manulifeLogoText: 'Manulife logo'
  },
  errors: {
    enterValidDate: 'Please enter a valid date'
  },
  labels: {
    optional: 'Optional'
  }
};
var enCA = {
  common: common,
  carousel: {
    leftArrow: function leftArrow(itemType) {
      return "Show previous ".concat(itemType);
    },
    rightArrow: function rightArrow(itemType) {
      return "Show next ".concat(itemType);
    },
    disabled: 'disabled',
    displayed: function displayed(itemType, direction) {
      return "".concat(direction, " ").concat(itemType, " is now displayed");
    },
    next: 'next',
    previous: 'previous',
    first: 'first',
    last: 'last',
    current: 'current item'
  },
  global: {
    month: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December'
    },
    day: {
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday'
    },
    dayAbbr: {
      sunday: 'S',
      monday: 'M',
      tuesday: 'T',
      wednesday: 'W',
      thursday: 'T',
      friday: 'F',
      saturday: 'S'
    },
    dateAbbr: {
      day: 'd',
      month: 'm',
      year: 'y'
    }
  },
  dataTable: {
    emptyTableMessage: 'The table has no rows',
    dropdownFilterDefault: 'All',
    textFilterPlaceholder: 'Search',
    currentItemAriaLabel: 'Current page',
    navigationAriaLabel: 'Page control',
    resetFilters: 'Reset table',
    filterAriaLabel: function filterAriaLabel(_ref) {
      var columnName = _ref.columnName;
      return "Filter the results by ".concat(columnName);
    },
    paginationResultsSize: function paginationResultsSize(_ref2) {
      var min = _ref2.min,
        max = _ref2.max,
        total = _ref2.total;
      return "Showing ".concat(min, "-").concat(max, " of ").concat(total);
    },
    selectedRowsCount: function selectedRowsCount(count) {
      return "".concat(count, " items selected");
    }
  },
  datePicker: {
    toggleButtonTitle: 'Toggle datepicker',
    toggleNextMonthTitle: 'Go to next month',
    togglePreviousMonthTitle: 'Go to previous month',
    dateFormatInvalid: common.errors.enterValidDate,
    dateOutsideRangeTemplate: function dateOutsideRangeTemplate(_ref3) {
      var before = _ref3.before,
        after = _ref3.after;
      if (before && after) {
        return "Please enter a date between ".concat(before, " and ").concat(after);
      }
      if (before) {
        return "Please enter a date after ".concat(before);
      }
      if (after) {
        return "Please enter a date before ".concat(after);
      }
      return common.errors.enterValidDate;
    }
  },
  dateOfBirth: {
    legend: 'Date of birth',
    day: 'Day',
    month: 'Month',
    year: 'Year',
    dayPlaceholder: 'dd',
    monthPlaceholder: 'Select',
    yearPlaceholder: 'yyyy',
    invalidDate: 'Please enter a valid date',
    beyondMinTemplate: function beyondMinTemplate(_ref4) {
      var before = _ref4.before;
      return "Please enter a date after ".concat(before);
    },
    beyondMaxTemplate: function beyondMaxTemplate(_ref5) {
      var after = _ref5.after;
      return "Please enter a date before ".concat(after);
    }
  },
  expandableParagraph: {
    showLess: 'Show less',
    showMore: 'Show more'
  },
  fileUpload: {
    errorFileType: 'Sorry, that file type didn’t work. Please try again.',
    errorFileSize: 'Sorry, that file was too large. Please try again.',
    errorCombinedFileSize: 'Sorry, your files exceed the combined maximum file size of',
    errorFileDuplicate: "Sorry, it looks like you've already uploaded that file.",
    inputAriaLabel: 'File input, click to select a file',
    maxFilesMessage: 'You have uploaded the maximum number of files.',
    instructionsMobile: 'Browse your files',
    instructionsDragDrop: 'Drag and drop it here',
    instructionsOr: 'OR',
    instructionsBrowse: 'browse your files',
    smallLabel: 'Browse your files',
    files: 'Files:',
    fileNameTemplate: function fileNameTemplate(fileName) {
      return "File name ".concat(fileName);
    },
    fileSizeTemplate: function fileSizeTemplate(fileSize) {
      return "File size ".concat(fileSize);
    },
    view: 'View',
    viewAriaTemplate: function viewAriaTemplate(fileName) {
      return "View ".concat(fileName);
    },
    delete: 'Delete',
    deleteAriaTemplate: function deleteAriaTemplate(fileName) {
      return "Delete ".concat(fileName);
    },
    close: 'Close',
    unitByte: 'B',
    unitKilobyte: 'kB',
    unitMegabyte: 'MB'
  },
  footer: {
    copyright: 'Copyright',
    logoAltText: common.branding.manulifeLogoText,
    defaultCopyrightText: 'The Manufacturers Life Insurance Company',
    quickLinksHeader: 'Quick Links',
    externalLinkText: 'Open in a new tab'
  },
  messageCard: {
    closeIconAriaLabelDefault: 'Dismiss message'
  },
  mobileInput: {
    countryCodeLabel: 'Country code',
    phoneNumberLabel: 'Phone number'
  },
  modal: {
    closeButtonAriaLabelDefault: 'Close Modal'
  },
  pagination: {
    previousAltText: 'Previous',
    nextAltText: 'Next',
    preposition: 'of'
  },
  plusMinus: {
    ariaLabelPlusDefault: 'Increase Value',
    ariaLabelMinusDefault: 'Decrease Value'
  },
  progressBar: {
    ariaLabelComplete: 'Complete',
    ariaLabelCurrent: 'Current',
    labelTemplate: function labelTemplate(_ref6) {
      var currentStep = _ref6.currentStep,
        totalSteps = _ref6.totalSteps;
      return "Step ".concat(currentStep, " of ").concat(totalSteps);
    },
    loading: 'Loading'
  },
  select: {
    placeholder: 'Select'
  },
  sideNav: {
    menuHeaderLinkAltText: 'Manulife home',
    brandLinkAlt: 'Manulife home',
    currentAriaLabel: 'current',
    menuItemAriaLabel: 'menu item',
    subMenuAriaLabel: 'submenu',
    subMenuStartsAriaLabel: 'Submenu starts - ',
    subMenuEndsAriaLabel: ' - end of submenu',
    secondaryAriaLabel: 'Secondary',
    menuTitleAriaLabel: 'menu title',
    primaryAriaLabelDesktop: 'Primary',
    primaryAriaLabelMobile: 'Mobile',
    currentSectionAriaLabel: 'current section',
    languageToggleText: 'Français',
    hamburgerLogoAlt: common.branding.manulifeLogoText,
    mobileMenuSignInText: 'Sign in',
    mobileMenuSignOutText: 'Sign out',
    mobileContactUsText: 'Contact us',
    hamburgerOpenAriaLabel: 'Open menu',
    hamburgerCloseAriaLabel: 'Close menu',
    // new SideNav
    brandLogo: common.branding.manulifeLogoText,
    wordmarkLogo: common.branding.manulifeLogoText,
    hamburgerOpen: 'Open menu',
    hamburgerOpenLabel: 'Menu',
    hamburgerClose: 'Close menu',
    hamburgerCloseLabel: 'Close',
    mobileFooterSection: 'Mobile navigation bottom links',
    externalLinkText: 'Open in a new tab'
  },
  table: {
    columnSortable: 'column is sortable',
    sortedAscending: 'sorted ascending',
    sortedDescending: 'sorted descending',
    activateSortAscending: 'activate to sort column ascending',
    activateSortDescending: 'activate to sort column descending',
    emptyTableMessage: 'The table has no rows'
  },
  textArea: {
    maxLengthAriaLabelTemplate: function maxLengthAriaLabelTemplate(current, max) {
      return "Character count ".concat(current, " of ").concat(max);
    }
  },
  textInput: {
    show: 'SHOW',
    showPasswordAriaLabel: 'Show password',
    hide: 'HIDE',
    hidePasswordAriaLabel: 'Hide password',
    passwordDisplayed: 'Password is currently displayed',
    passwordHidden: 'Password is currently hidden',
    passwordNowDisplayed: 'Password is now displayed',
    passwordNowHidden: 'Password is now hidden'
  },
  textLink: {
    externalLinkText: 'Open in a new tab'
  },
  tooltip: {
    ariaLabelDefault: 'tooltip',
    close: 'close tooltip'
  },
  utilityHeader: {
    currentSectionAriaLabel: 'current section',
    langToggleAriaLabel: 'Français',
    langToggleText: 'fr',
    mobileLogoAlt: common.branding.manulifeLogoText,
    skipToMainNavText: 'Skip to main navigation',
    skipToMainContentText: 'Skip to main content',
    skipToSubMenuText: 'Skip to submenu',
    skipToFooterText: 'Skip to footer',
    navAriaLabel: 'Global',
    signOutLabel: 'Sign out',
    // new utilityHeader
    skipToMainContentLabel: 'Skip to main content',
    skipToMainNavLabel: 'Skip to primary navigation',
    skipToSubNavLabel: 'Skip to secondary navigation',
    skipToFooterLabel: 'Skip to footer',
    contactUsLabel: 'Contact us',
    langAbbreviation: 'fr',
    langLabel: 'Français',
    langAriaLabel: 'Français',
    logoAriaLabel: common.branding.manulifeLogoText,
    profileLabel: 'Profile',
    searchLabel: 'Search',
    signInLabel: 'Sign in'
  }
};

export { enCA as default };
